module.exports = __webpack_public_path__ + "static/media/9DESA24.23dac0ac.jpg";